module.exports = __webpack_public_path__ + "1793882494189/fonts/socicon.944f06f.woff";